import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const Styles = css`
  .custom-phone-number-field {
    position: relative;
    ${(props) =>
      props.addressBook
        ? `
      `
        : `margin-top: -19px;
        `};
  }
  .placeHolder {
    ${(props) =>
      props.addressBook
        ? `top:7px;
      `
        : `top: 10px;
        `};
    ${(props) => (!props.addressBook ? 'z-index: 100;' : 'z-index: 2;')}
    left: 11px;
    background: white;
    width: fit-content;
    padding: ${(props) => (props.addressBook ? '0px' : '0px 5px')};
    align-items: center;
    display: flex;
    justify-content: center;
    font-weight: ${(props) => props.theme.fonts.fontWeight.extrabold};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    ${(props) =>
      props.addressBook
        ? `
            font-size: 10px;
            font-weight: 700;
            letter-spacing: normal;
            text-align: left;
            color: #1a1a1a;
            justify-content: left;
            left: 0;
                position: absolute;
      `
        : `    position: relative;
        `};
  }
  .placeholder-error {
    color: ${(props) =>
      props.addressBook
        ? `
            #1a1a1a;
      `
        : `${props.theme.colorPalette.red[500]}`};
  }
  .placeholder-success {
    color: ${(props) =>
      props.addressBook
        ? `
            #1a1a1a;
      `
        : `${props.theme.colorPalette.blue[800]}`};
  }
  ${(props) =>
    props.addressBook
      ? `
            .flag-container {
                margin-top: 14px;
            }
                .error-component {
                  position:relative;
                  padding-left:24px;
                }
      `
      : `
        `};
  .warning-icon {
    position: absolute;
    left: 0;
    background: transparent url(${(props) => getIconPath('circle-alert-fill', props)}) no-repeat 0 0;
    background-size: contain;
    border: none;
    height: 14px;
    width: 16px;
    margin-right: 7px;
    flex-shrink: 0;
  }
  .intl-tel-input {
    display: block;
    margin: 0 0 10px;
  }
  .intl-tel-input .form-control {
    padding: 12px 15px;
    width: ${(props) => (props.isPlccIC ? `100%` : `100.5%`)};
    border-radius: 6px;
    height: 55px;
    border: ${(props) =>
      props.meta.valid ? `1px solid ${props.theme.colorPalette.blue[800]}` : `1px solid #c3c3c3`};
  }
  .intl-tel-input .form-control:focus {
    border: ${(props) => `1px solid ${props.theme.colorPalette.blue[800]}`};
  }

  .intl-tel-input .form-control-error {
    padding: 12px 15px;
    width: 100.5%;
    border-radius: 6px;
    height: 55px;
    border: ${(props) => `1px solid ${props.theme.colorPalette.red[500]}`};
    ${(props) =>
      props.addressBook ? `border-bottom:1px solid ${props.theme.colorPalette.red[500]}` : ''}
  }
  .form-control::placeholder,
  .form-control-error::placeholder {
    color: ${(props) => `${props.theme.colorPalette.gray[800]}`};
  }
  .intl-tel-input .selected-flag {
    height: 100%;
    width: 50px;
    display: flex;
    ${(props) => (props.addressBook ? 'justify-content: flex-start;' : '')}
  }

  .intl-tel-input.allow-dropdown.separate-dial-code .selected-flag {
    display: flex;
    width: ${(props) => (props.addressBook ? '35px' : '70px')};
    background-color: rgba(0, 0, 0, 0);
  }
  .intl-tel-input.allow-dropdown.separate-dial-code .selected-flag:hover {
    ${(props) => (!props.addressBook ? 'background-color: rgba(0, 0, 0, 0.05);' : '')}
  }

  .intl-tel-input.allow-dropdown.separate-dial-code input,
  .intl-tel-input.allow-dropdown.separate-dial-code input[type='text'],
  .intl-tel-input.allow-dropdown.separate-dial-code input[type='tel'] {
    padding-left: 75px;
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.fonts.fontWeight.medium};
    line-height: normal;

    ${(props) =>
      props.addressBook
        ? `
        border: 0 solid transparent;
        border-bottom: 1px solid ${props.theme.colors.FOOTER.DIVIDER};
        padding-bottom: ${props.theme.spacing.ELEM_SPACING.XS};
        padding-top: 24px;
        height:auto;
        border-radius:0;
        padding-left: 45px;
      `
        : `
        `};
  }
  .intl-tel-input.allow-dropdown.separate-dial-code input::placeholder {
    color: #595959;
    font-size: ${(props) => (props.addressBook ? '13px' : '16px')};
  }
  .intl-tel-input.allow-dropdown.separate-dial-code input:focus-visible,
  .intl-tel-input.allow-dropdown.separate-dial-code input[type='text']:focus-visible,
  .intl-tel-input.allow-dropdown.separate-dial-code input[type='tel']:focus-visible {
    outline: none;
    background-color: transparent;
  }

  .intl-tel-input .flag-dropdown {
    padding: 5px;
  }

  .intl-tel-input .country-list {
    max-height: 200px;
    overflow-y: auto;
    width: 100%;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .intl-tel-input .country {
    padding: 10px 15px;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code .selected-dial-code {
    display: none;
  }
  .iti-flag {
    margin-right: 4px;
  }

  .input-text-active-placeholder {
    z-index: 99;
    position: absolute;
  }
  .intl-tel-input.allow-dropdown.separate-dial-code input[type='tel'].form-control-error {
    ${(props) =>
      props.addressBook ? `border-bottom:1px solid ${props.theme.colorPalette.red[500]}` : ''}
  }
`;

export default Styles;
